<template>
  <div v-if="!isPresentation">
    <UserInfo v-if="isLoggedIn" />

    <CtaButton :onClick="onLoginClick" v-if="!isLoggedIn" label="Sign In" />
    <div v-if="!isLoggedIn" class="register-block">
      <span @click="onRegisterClick" class="menu-item">
        Create an Account
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Balance from "./Balance";
import UserInfo from "./UserInfo";
import Tab from "./Tab";
import CtaButton from "./header/CtaButton";

export default {
  name: "UserMenu",
  components: {
    CtaButton,
    Tab,
    Balance,
    UserInfo
  },
  props: {
    closePopup: Function
  },
  computed: {
    ...mapState("auth", ["isLoggedIn"]),
    ...mapState("app", ["isPresentation"])
  },
  methods: {
    onLoginClick() {
      this.closePopup();
      this.$router.push("/login");
    },
    onRegisterClick() {
      this.closePopup();
      this.$router.push("/registration");
    }
  }
};
</script>

<style scoped>
.register-block {
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: #0821ff;
  margin-top: 16px;
}
</style>
